import { Injectable } from '@angular/core';
import { DynamicDialogRef, DialogService as PrimeNGDialogService } from 'primeng/dynamicdialog';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private _dialog: PrimeNGDialogService) { }

  open(component: any, options?: any): DynamicDialogRef<any> {
    return this._dialog.open(component, options);
  }
}